export default __webpack_public_path__ + "static/media/dribbble.146272f4.svg";